import React from 'react';
import { Dialog, Card, CardContent, Typography, Grid, Box } from '@mui/material';
import LoadingButton from '@mui/lab/LoadingButton';
import AssessmentOutlinedIcon from '@mui/icons-material/AssessmentOutlined';
import { useTranslation } from 'react-i18next';

interface StatisticDialogProps {
    isOpen: boolean;
    onClose: () => void;
    statistic: {
        total: number;
        matched: number;
        unmatched: number;
    };
    handleDownloadResult: () => void;
    downloading: boolean;
}

const StatisticDialog: React.FC<StatisticDialogProps> = ({ isOpen, onClose, statistic, handleDownloadResult, downloading }) => {
    const { t } = useTranslation();
    
    return (
        <Dialog open={isOpen} onClose={onClose}>
            <Card sx={{ minWidth: 275, padding: 0, borderRadius: "10px" }}>
                <CardContent sx={{ paddingBottom: '16px !important' }}>
                    <Typography variant="h6" gutterBottom sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                        {t('stats.resultStatistic')}
                        <AssessmentOutlinedIcon />
                    </Typography>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "flex-end" }}>
                                <Typography variant="body1" gutterBottom sx={{ width: '510px', wordWrap: 'break-word' }}>
                                    {t('stats.total')}
                                </Typography>
                                <Typography variant="body1" gutterBottom>
                                    {statistic.total}
                                </Typography>
                            </Box>
                            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "flex-end" }}>
                                <Typography variant="body1" gutterBottom sx={{ width: '510px', wordWrap: 'break-word' }}>
                                    {t('stats.matched')}
                                </Typography>
                                <Typography variant="body1" gutterBottom>
                                    {statistic.matched}
                                </Typography>
                            </Box>
                            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "flex-end" }}>
                                <Typography variant="body1" gutterBottom sx={{ width: '510px', wordWrap: 'break-word' }}>
                                    {t('stats.unmatched')}
                                </Typography>
                                <Typography variant="body1" gutterBottom>
                                    {statistic.unmatched}
                                </Typography>
                            </Box>
                            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "flex-end" }}>
                                <Typography variant="body1" gutterBottom sx={{ width: '510px', wordWrap: 'break-word' }}>
                                    <strong>{t('stats.saved')}</strong>
                                </Typography>
                                <Typography variant="body1" gutterBottom>
                                    <strong>{`${Math.round(statistic.matched / statistic.total * 100)}%`}</strong>
                                </Typography>
                            </Box>
                        </Grid>
                        <Box sx={{ display: "flex", justifyContent: "center", width: "100%" }}>
                            <LoadingButton onClick={handleDownloadResult} loading={downloading}>
                                {t('stats.download')}
                            </LoadingButton>
                        </Box>
                    </Grid>
                    <Typography gutterBottom textAlign="center">
                        {t('stats.thanks')}
                    </Typography>
                </CardContent>
            </Card>
        </Dialog>
    );
};

export default StatisticDialog;